import { render, staticRenderFns } from "./InterpretationPendingTable.vue?vue&type=template&id=a2c1cf66&"
import script from "./InterpretationPendingTable.vue?vue&type=script&lang=js&"
export * from "./InterpretationPendingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports